import { useId, useRef, useState } from 'react';
import styles from './ServiceAccountUpload.module.css';

type Props = {
  onLoad: (text: string, fileName: string) => void;
  loadedName: string | null;
  loadedSize: number | null;
  onClear: () => void;
};

export function ServiceAccountUpload({ onLoad, loadedName, loadedSize, onClear }: Props) {
  const inputId = useId();
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);

  function readFile(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        onLoad(reader.result, file.name);
      }
    };
    reader.readAsText(file);
  }

  function onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) readFile(file);
  }

  function onDrop(e: React.DragEvent) {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (file && (file.name.endsWith('.json') || file.type.includes('json'))) {
      readFile(file);
    }
  }

  const hasFile = Boolean(loadedName);

  return (
    <div className={styles.wrap}>
      <span className={styles.label} id={`${inputId}-label`}>
        Service account JSON
      </span>
      <span className={styles.hint}>Google Cloud → IAM → Service account → Keys (JSON)</span>

      {hasFile ? (
        <div className={styles.fileCard}>
          <div className={styles.fileIcon} aria-hidden>
            {'{ }'}
          </div>
          <div className={styles.fileMeta}>
            <span className={styles.fileName}>{loadedName}</span>
            {loadedSize != null ? (
              <span className={styles.fileSize}>{Math.round(loadedSize / 1024)} KB · klaar voor sync</span>
            ) : null}
          </div>
          <button
            type="button"
            className={styles.changeBtn}
            onClick={() => {
              if (inputRef.current) inputRef.current.value = '';
              onClear();
            }}
          >
            Vervangen
          </button>
        </div>
      ) : (
        <label
          htmlFor={inputId}
          className={`${styles.dropzone} ${dragOver ? styles.dropzoneActive : ''}`}
          onDragOver={(e) => {
            e.preventDefault();
            setDragOver(true);
          }}
          onDragLeave={() => setDragOver(false)}
          onDrop={onDrop}
        >
          <span className={styles.dropIcon} aria-hidden>
            ↑
          </span>
          <span className={styles.dropTitle}>Sleep JSON hierheen</span>
          <span className={styles.dropSub}>of klik om een bestand te kiezen</span>
        </label>
      )}

      <input
        ref={inputRef}
        id={inputId}
        className={styles.hiddenInput}
        type="file"
        accept="application/json,.json"
        aria-labelledby={`${inputId}-label`}
        onChange={onInputChange}
      />
    </div>
  );
}
